<template>
  <div
    class="flex items-center gap-x-1.5 px-3 py-2 text-white bg-transparent rounded-md cursor-pointer transition-colors hover:text-gray-600 hover:bg-white"
    @click="openExternalLink"
  >
    <slot v-if="$slots.default"></slot>
    <template v-else>{{ name }}</template>
    <sup class="text-xs">
      <font-awesome-icon icon="fa-solid fa-arrow-up-right-from-square" />
    </sup>
  </div>
</template>

<script setup>
const props = defineProps({
  name: {
    type: String,
    required: true
  },
  to: {
    type: String,
    required: true
  },
  childrenMenu: {
    type: Array,
    required: true
  },
  parent: {
    type: [Number, null],
    required: true
  }
})

function openExternalLink() {
  window.open(props.to, '_blank', 'noopener')
}
</script>
